import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectGroup,
  SelectLabel,
} from '@/components/ui/select';
import { type IAgreementUpdateParams, LiabilityEnum } from 'src/graphql/schema';
import { Badge } from '@/components/ui/badge';

const options = [
  {
    label: 'Standard limit',
    value: LiabilityEnum.Total_0,
  },
  {
    label: '$50,000 total aggregate',
    value: LiabilityEnum.Total_29,
  },
  {
    label: '$100,000 total aggregate',
    value: LiabilityEnum.Total_89,
  },
  {
    label: '$250,000 total aggregate',
    value: LiabilityEnum.Total_149,
  },
];

type Props = {
  onUpdate: (agreementParams: IAgreementUpdateParams) => void;
  liability?: LiabilityEnum;
};

const AgreementLiabilitySettings = ({ onUpdate, liability }: Props) => {
  const onUpdateLiability = (liability: LiabilityEnum) => onUpdate({ liability });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Escrow Agreement Liability SLA</CardTitle>
        <CardDescription>
          Specify the total aggregate liability limit for the escrow agent in the agreement. By default, the escrow
          agreement excludes full liability, similar to other source code management platforms, with a cap set at 12
          months&apos; fees.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Select value={liability ?? ''} onValueChange={onUpdateLiability}>
          <SelectTrigger className="w-full mb-2 *:data-[slot=select-value]:grow *:data-[slot=select-value]:justify-between *:data-[slot=select-value]:gap-2">
            <SelectValue placeholder="Select liability amount" />
          </SelectTrigger>
          <SelectContent className="group/select">
            <SelectGroup>
              <SelectLabel>Liability amount</SelectLabel>
              {options.map(({ label, value }) => (
                <SelectItem key={value} value={value} className="*:[span]:justify-between *:[span]:grow *:[span]:gap-2">
                  {label}
                  {value !== LiabilityEnum.Total_0 && <Badge>Add-on</Badge>}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
        <div className="flex items-start gap-1.5">
          <p className="text-sm text-muted-foreground">
            Selecting non-standard limits will require a Liability SLA Add-On.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default AgreementLiabilitySettings;
